<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 pt-2 :class="{'ml-5': $vuetify.breakpoint.mdAndUp}">
        <v-btn
          color="primary"
          outline
          :block="$vuetify.breakpoint.smAndDown"
          class="ml-0"
          @click="open()"
        >
          <v-icon left color="primary">people</v-icon>
          {{ agents.length }} / {{ $tc('agents', $store.state._User.colleagues.length, { count: $store.state._User.colleagues.length }) }}
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- Sélectionner les agents -->
    <v-dialog v-model="dialog" scrollable persistent max-width="350px">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('select') | cap }} {{ $tc('agents', 2, { count: ' ' }) }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px;">
          <v-data-table
            :headers="header"
            :items="$store.state._User.colleagues"
            v-model="agentsTmp"
            item-key="USR_ID"
            select-all="primary"
            class="elevation-1"
            hide-actions
            :total-items="$store.state._User.colleagues.length"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    color="primary"
                    hide-details
                    @click.native="toggleAll"
                    :input-value="props.all || (agentsTmp.length == agents.length)"
                    :indeterminate="props.indeterminate"
                  ></v-checkbox>
                </th>
                <th class="text-xs-left">
                  <span class="subheading">{{ header[0].text }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  v-if="withoutMe && (props.item.USR_ID == $store.state._User.id)"
                  color="primary"
                  hide-details
                  value
                  :input-value="iAmChoosen"
                ></v-checkbox>
                <v-checkbox
                  v-else
                  color="primary"
                  hide-details
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                <wz-avatar
                  :username="props.item.USR_FIRST_NAME  + ' ' + props.item.USR_LAST_NAME"
                  :src="`${domaine}/media/user/small/${props.item.USR_ID}_avatar.jpg`"
                  size="35px"
                ></wz-avatar>
                <span class="ml-2">
                  {{ props.item.USR_FIRST_NAME + ' ' + props.item.USR_LAST_NAME }}
                </span>
                <span v-if="(props.item.USR_ID == $store.state._User.id)">
                  ({{ $t('me') }})
                </span>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="cancel()">{{ $t('cancel') }}</v-btn>
          <v-btn :disabled="agentsTmp.length < min" color="primary" @click="submit()">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { DOMAINE } from '../../constants'
export default {
  props: {
    /**
     * Agents sélectionnés
     */
    agents: {
      type: Array,
      required: true
    },
    /**
     * Agents sélectionnables
     */
    agentsInit: {
      type: Array,
      required: true
    },
    /**
     * Indique si l'utilisateur
     * ne doit pas apparaître dans
     * la liste des agents
     */
    withoutMe: {
      type: Boolean,
      default: false
    },
    /**
     * Indique le nombre d'agents
     * qui doivent être sélectionnés
     */
    min: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      domaine: DOMAINE,
      /**
       * Agents sélectionnés dans le dialog
       * @type {Array}
       */
      agentsTmp: null,
      /**
       * Indique si le dialog est ouvert
       * @type {Boolean}
       */
      dialog: false,
      /**
       * Indique si l'agent est choisi dans la liste
       * @type {Boolean}
       */
      iAmChoosen: false
    }
  },

  created () {
    this.agentsTmp = this.agents
    this.iAmChoosen = !_.isNil(_.find(this.agentsTmp, {'USR_ID': this.$store.state._User.id}))
  },

  computed: {
    header () {
      return this.agentsTmp && !this.agentsTmp.length
      ? [{text: _.upperFirst(this.$t('none')), align: 'left', sortable: false}]
      : [{text: _.upperFirst(this.$tc('all', 1)), align: 'left', sortable: false}]
    }
  },

  methods: {
    open () {
      this.agentsTmp = this.agents
      this.dialog = true
    },
    submit () {
      this.$emit('update:agents', this.agentsTmp)
      this.dialog = false
    },
    cancel () {
      this.dialog = false
    },
    toggleAll () {
      if (this.agentsTmp.length) this.agentsTmp = []
      else this.agentsTmp = this.agentsInit.slice()
    }
  },

  watch: {
    /**
     * Empêche de changer la valeur de l'agent
     * si le props 'withoutMe' est 'vrai'
     */
    agentsTmp (newVal, oldVal) {
      if (this.withoutMe && oldVal) {
        // recherche si l'utilisateur est dans les agents cochés auparavant
        let meInOld = _.find(oldVal, {'USR_ID': this.$store.state._User.id})
        let meInNew = _.findIndex(newVal, {'USR_ID': this.$store.state._User.id})
        // si oui : doit se retrouver dans newVal
        // sinon : doit être supprimer de newVal
        if (meInOld) {
          if (meInNew === -1) {
            newVal.push(meInOld)
          }
        } else {
          if (meInNew !== -1) {
            newVal.splice(meInNew, 1)
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSelectAgents.vue